"use client";

import { ClerkProvider } from "@clerk/nextjs";
import { QueryProvider } from "@/providers/query-provider";
import ClerkAuthProvider from "@/providers/session-provider";
import { AuthWrapper } from "@/components/AuthWrapper";
import { clerkConfig, isClerkConfigured } from "@/lib/clerk-config";
import { ReactNode } from "react";
import { DrawerProvider } from "@/contexts/DrawerContext";
import { ToastProvider } from "@/components/ui/toast";

interface ProvidersProps {
  children: ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  if (!isClerkConfigured()) {
    console.error(
      "Missing NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY. Please add it to your .env.local file."
    );
  }

  return (
    <ClerkProvider
      publishableKey={clerkConfig.publishableKey}
      signInUrl={clerkConfig.signInUrl}
      signUpUrl={clerkConfig.signUpUrl}
      signInFallbackRedirectUrl={clerkConfig.signInFallbackRedirectUrl}
      signUpFallbackRedirectUrl={clerkConfig.signUpFallbackRedirectUrl}
      {...(clerkConfig.signInForceRedirectUrl && {
        signInForceRedirectUrl: clerkConfig.signInForceRedirectUrl,
      })}
      {...(clerkConfig.signUpForceRedirectUrl && {
        signUpForceRedirectUrl: clerkConfig.signUpForceRedirectUrl,
      })}
      appearance={{
        layout: {
          unsafe_disableDevelopmentModeWarnings: true,
        },
        elements: {
          userButtonPopoverCard: "z-50 shadow-lg",
          userButtonPopoverFooter: "hidden",
        },
      }}
    >
      <QueryProvider>
        <ClerkAuthProvider>
          <ToastProvider>
            <DrawerProvider>
              <AuthWrapper>{children}</AuthWrapper>
            </DrawerProvider>
          </ToastProvider>
        </ClerkAuthProvider>
      </QueryProvider>
    </ClerkProvider>
  );
}

